import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Grid,
  alpha,
} from '@mui/material';
import BaseTab from './BaseTab';

interface BackendWebSocketTabProps {
  isDark: boolean;
  colors: any;
  discordFont: any;
  glassStyle: any;
  lokiGradient: string;
  goldColor: string;
  isMobile: boolean;
}

const BackendWebSocketTab: React.FC<BackendWebSocketTabProps> = (props) => {
  return (
    <BaseTab
      {...props}
      title="Backend WebSocket Integration"
      emoji="🔌"
    >
      <Typography variant="h6" sx={{ color: props.goldColor, mb: 3 }}>
        Real-time WebSocket Integration
      </Typography>

      <Paper sx={{ bgcolor: alpha('#051814', 0.8), p: 3, borderRadius: 2, mb: 3 }}>
        <Typography variant="h6" sx={{ color: props.goldColor, mb: 2 }}>
          Connection Details
        </Typography>
        <Box sx={{ mb: 2 }}>
          <Typography variant="body2" color={props.goldColor} fontFamily="monospace">
            WebSocket Server: /ws/chat
          </Typography>
          <Typography variant="caption" color={props.colors.textSecondary}>
            Connect to this endpoint for real-time chat functionality
          </Typography>
        </Box>
      </Paper>

      <Typography variant="h6" sx={{ mb: 2, color: props.goldColor }}>
        Message Types
      </Typography>
      <Grid container spacing={2} sx={{ mb: 3 }}>
        {[
          { type: 'auth', desc: 'Authenticate WebSocket connection', color: props.goldColor },
          { type: 'message', desc: 'Send/receive chat messages', color: '#0F3B2E' },
          { type: 'ping', desc: 'Keep-alive ping', color: '#1D5C4A' },
          { type: 'history', desc: 'Receive chat history', color: props.goldColor },
        ].map((msg, idx) => (
          <Grid size={{ xs: 12, sm: 6, md: 3 }} key={idx}>
            <Paper sx={{ p: 2, borderLeft: `4px solid ${msg.color}` }}>
              <Typography variant="subtitle2" fontWeight={700} sx={{ color: msg.color }}>
                {msg.type}
              </Typography>
              <Typography variant="caption" color={props.colors.textSecondary}>
                {msg.desc}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>

      <Typography variant="h6" sx={{ mb: 2, color: props.goldColor }}>
        Example Connection
      </Typography>
      <Paper sx={{ bgcolor: '#1E1F22', p: 3, borderRadius: 2 }}>
        <Typography variant="body2" fontFamily="monospace" color={props.goldColor} sx={{ lineHeight: 1.8 }}>
          const ws = new WebSocket('ws://localhost:3000/ws/chat');<br /><br />
          
          ws.onopen = () ={'>'} &#123;<br />
          &nbsp;&nbsp;// Authenticate<br />
          &nbsp;&nbsp;ws.send(JSON.stringify(&#123;<br />
          &nbsp;&nbsp;&nbsp;&nbsp;type: 'auth',<br />
          &nbsp;&nbsp;&nbsp;&nbsp;userId: 'user_id_here'<br />
          &nbsp;&nbsp;&#125;));<br />
          &#125;;<br /><br />
          
          ws.onmessage = (event) ={'>'} &#123;<br />
          &nbsp;&nbsp;const data = JSON.parse(event.data);<br />
          &nbsp;&nbsp;// Handle incoming messages<br />
          &#125;;
        </Typography>
      </Paper>
    </BaseTab>
  );
};

export default BackendWebSocketTab;